import type { FetchQueryOptions } from '@tanstack/react-query';

import stringifySearchParams from '@/utils/stringifySearchParams';

import type { JobsData } from '../_components/types';

const BASE_URL = 'https://apply.workable.com/api/v1/widget/accounts/327276';

const getJobs = async (location?: string): Promise<JobsData> => {
  const queryString = stringifySearchParams({ location });
  const url = queryString ? `${BASE_URL}?${queryString}` : BASE_URL;
  const response = await fetch(url);

  if (!response.ok) {
    throw new Error('Error fetching jobs from Workable API');
  }

  return response.json() as Promise<JobsData>;
};

export const withQueryKey = (
  location = '',
): FetchQueryOptions<JobsData, Error, JobsData, string[], never> => ({
  queryKey: ['jobs', location],
  queryFn: () => getJobs(location),
});
